<!--客户资产明细-->
<template>
    <div>
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box  flex-y-center flex-between">
            <div v-if="postId!=42&&postId!=2" class="select-item mr-30 flex-between flex-y-center" @click="selectEmployeePopup">
                <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <!-- <div class="select-item ml-30 flex flex-between flex-y-center" @click="selectSortPopup">
                <div class="select-tit">{{ checkedSort && checkedSort.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div> -->
        </div>
        <div class="search-num">
            <form action="javascript:return true">
                <div> 总资产大于<input type="number" v-model="propertyAmount" @keyup.13="onAmountSearch" placeholder="自定义"
                        class="num-input" /> 万</div>
            </form>
        </div>
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="onLoad"
                    :offset="20" :immediate-check="false">
                    <div class="customer-list" v-for="(item, index) in assetList" :key="index"
                        @click="toDetail(item.custId,item.phone)">
                        <div class="flex-row mb-45">
                            <img class="customerHeadPortrait" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                            <div class="customer-info flex-1 flex-col flex-between">
                                <div class="customer-name">{{item.name}}
                                </div>
                                <img class="card-icon" :src="item.cardImageSmallUrl" alt="">
                            </div>
                            <div class="emp-box  flex-col flex-between">
                                <div class="churn-time">总资产：<span class="emp-name">{{item.customerPropertyAmount}}万</span></div>
                                <div class="churn-time" v-if="dimension==1">专属：<span class="emp-name">{{item.empName}}</span>
                                </div>
                                <div class="churn-time" v-if="dimension==2||dimension==3">
                                    {{dimension==2?'主诊':dimension==3?'健康顾问':''}}：<span
                                        class="emp-name">{{item.doctorAdviserName}}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="dimension==1">
                            <div class="customer-remark flex-between flex-y-center">
                                <div class="sale-name">
                                    护理(万)
                                </div>
                                <div class="sale-name">
                                    产品(万)
                                </div>
                                <div class="sale-name">
                                    卡余(万)
                                </div>
                                <div class="sale-name">
                                    券余(万)
                                </div>
                                <div class="sale-name" style="width:96px">
                                    医美/抗衰(万)
                                </div>
                            </div>
                            <div class="customer-remark flex-between flex-y-center">
                                <div class="sale-num">
                                    {{item.lifeServiceAmount}}
                                </div>
                                <div class="sale-num">
                                    {{item.lifeProductAmount}}
                                </div>
                                <div class="sale-num">
                                    {{item.lifeCardBalanceAmount}}
                                </div>
                                <div class="sale-num">
                                    {{item.liftCouponAmount}}
                                </div>
                                <div class="sale-num" style="width:94px">
                                    {{item.medicalAmount}}
                                </div>
                            </div>
                        </div>
                        <div v-if="dimension==2">
                            <div class="customer-remark flex-start flex-y-center">
                                <div class="sale-name-ym">
                                    手术(万)
                                </div>
                                <div class="sale-name-ym">
                                    身体塑形(万)
                                </div>
                                <div class="sale-name-ym">
                                    无创提拉(万)
                                </div>
                                <div class="sale-name-ym">
                                    复合微整(万)
                                </div>
                            </div>
                            <div class="customer-remark flex-start flex-y-center mb-30">
                                <div class="sale-num-ym">
                                    {{item.shouShuAmount}}
                                </div>
                                <div class="sale-num-ym">
                                    {{item.shenTiSuXingAmount}}
                                </div>
                                <div class="sale-num-ym">
                                    {{item.wuChuangTiLaAmount}}
                                </div>
                                <div class="sale-num-ym">
                                    {{item.fuHeWeiZhengAmount}}
                                </div>
                            </div>
                            <div class="customer-remark flex-start flex-y-center">
                                <div class="sale-name-ym">
                                    肤质管理(万)
                                </div>
                                <div class="sale-name-ym">
                                    肤色管理(万)
                                </div>
                                <div class="sale-name-ym">
                                    券余(万)
                                </div>
                                <div class="sale-name-ym">
                                    未分类(万)
                                </div>
                            </div>
                            <div class="customer-remark flex-start flex-y-center">
                                <div class="sale-num-ym">
                                    {{item.fuZhiGuanLiAmount}}
                                </div>
                                <div class="sale-num-ym">
                                    {{item.fuSeGuanLiAmount}}
                                </div>
                                <div class="sale-num-ym">
                                    {{item.ymCouponAmount}}
                                </div>
                                <div class="sale-num-ym">
                                    {{item.otherAmount}}
                                </div>
                            </div>
                        </div>
                        <div v-if="dimension==3">
                            <div class="customer-remark flex-around flex-y-center">
                                <div class="sale-name-ks">
                                    女性特护(万)
                                </div>
                                <div class="sale-name-ks">
                                    再生(万)
                                </div>
                                <div class="sale-name-ks">
                                    功能(万)
                                </div>
                                <div class="sale-name-ks">
                                    券余(万)
                                </div>
                            </div>
                            <div class="customer-remark flex-around flex-y-center">
                                <div class="sale-num-ks">
                                    {{item.womanAmount}}
                                </div>
                                <div class="sale-num-ks">
                                    {{item.rebirthAmount}}
                                </div>
                                <div class="sale-num-ks">
                                    {{item.functionAmount}}
                                </div>
                                <div class="sale-num-ks">
                                    {{item.ksCouponAmount}}
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
            <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker title="全部员工" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange"></picker>
            </van-popup>
            <van-popup v-model="showSortPopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker title="总资产排序" v-model="checkedSort" :list="sortList" @change="onSortChange"></picker>
            </van-popup>

        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import Picker from '@/components/Picker';
import { getCookie } from '@/utils'
import { Search, Toast } from "vant";

export default {
    name: "storageAssetsDetails",
    components: {
        [Search.name]: Search, Picker
    },
    data() {
        return {
            postId: 0,
            showEmployeePopup: false,// 选择员工弹窗
            showSortPopup: false,// 选择卡弹窗
            searchStr: '',  // 搜索条件
            propertyAmount: '',  // 搜索条件
            page: 1,       // 当前页
            limit: 10,       // 每页多少条
            total: 0,     // 列表总条数
            assetList: [],    // 列表
            loading: false,    // 加载
            finished: false,    // 结束加载
            refreshing: false,   // 刷新
            sortList: [],// 排序
            checkedSort: null,//所选排序
            employeeList: [], // 员工
            checkedEmployee: null,//所选员工
            dimension: 0, //区分生美医美 1 生美 2 医美
        };
    },
    computed: {
    },
    mounted() {
        this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        this.$nextTick(() => {
            this.init()
        })
    },
    methods: {
        async init() {
            await this.getEmpList()
            await this.getSortList()
            this.onLoad()

        },
        onLoad() {
            this.loading = true
            let params = {
                propertySortType: 1,
                cateType: this.checkedSort.id,
                propertyAmount: this.propertyAmount,
                searchStr: this.searchStr,
                limit: 10,
                page: this.page,
                employeeId: this.checkedEmployee.id,
                id: this.$route.query.id,
                storeId: this.$route.query.storeId,
            }
            request({
                url: `/debt/storeCustomerProperty`,
                method: "get",
                params: params
            })
                .then((res) => {
                    this.assetList = this.page == 1 ? res.data.list : this.assetList.concat(res.data.list);
                    this.page += 1;
                    this.total = res.data.total;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.refreshing = false;
                    if (this.assetList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        // 获取员工列表
        getEmpList() {
            const sendData = {
                asset: 1,
                storeId: this.$route.query.storeId || '',
            }
            return request({
                url: this.dimension == 1 ? '/workEmployee/getEmployeeList' : "/sys/params/selectByStoreTreasure",
                method: "get",
                params: this.dimension == 1 ? '' : sendData
            })
                .then((res) => {
                    this.employeeList = res.data
                    this.checkedEmployee = this.employeeList[0] //默认全部

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 获取资产
        getSortList() {
            return request({
                url: "/debt/propertySortList",
                method: "get",
            })
                .then((res) => {
                    this.sortList = res.data
                    this.checkedSort = this.sortList[0] //默认全部
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        //搜索
        onSearch() {
            this.page = 1
            this.onLoad();
        },
        onAmountSearch() {
            this.page = 1
            this.onLoad();
            document.activeElement.blur();//关闭手机软键盘
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.assetList = [];
            this.refreshing = false;
            this.onLoad();
        },
        //查看详情
        toDetail(custId, phone) {
            this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.onRefresh()
        },
        // 弹窗
        selectEmployeePopup() {
            this.showEmployeePopup = true
        },
        selectSortPopup() {
            this.showSortPopup = true
        },
        // 筛选相关
        onEmployeeChange(data) {
            this.checkedEmployee = data
            this.showEmployeePopup = false
            this.onRefresh()
        },
        onSortChange(data) {
            this.showSortPopup = false
            this.checkedSort = data
            this.onRefresh()
        },
    },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    display: none;
}
.mr-30 {
    margin-right: 30px;
}
.mb-45 {
    margin-bottom: 45px;
}
.mb-30 {
    margin-bottom: 30px;
}
.search-num {
    height: 37px;
    font-size: 30px;
    line-height: 37px;
    margin: 40px 0 40px 31px;
}
.num-input {
    width: 200px;
    height: 60px;
    background: #f3f5f6;
    border-radius: 6px;
    border: none;
    margin: 0 20px;
    text-align: center;
}

.list-box {
    width: 100%;
    height: calc(100vh - 245px);
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
    padding: 40px 30px 30px 30px;
}

.customer-list {
    width: 690px;
    min-height: 291px;
    background: #fafafe;
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 30px 20px;
    .customer-info {
        height: 90px;
        .customer-name {
            min-width: 60px;
            height: 42px;
            font-size: 30px;
            color: #35434c;
            line-height: 42px;
            font-weight: 700;
        }
        .card-icon {
            width: 90px;
            height: 34px;
        }
    }
}
.churn-time {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin-top: 11px;
    text-align: right;
}
.nursing-edit-box {
    margin: 37px 0 0 163px;
}
.arrow_right {
    width: 15px;
    height: 26px;
    margin-top: 10px;
}

.card-image {
    height: 34px;
    width: 90px;
    margin: 24px 0 0 10px;
}
.customerHeadPortrait {
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 20px;
}
.emp-box {
    .emp-name {
        font-size: 26px;
        font-weight: 700;
        color: #35434c;
    }
}
.sale-name {
    width: 100px;
    height: 40px;
    font-size: 24px;
    color: #a0acb5;
    line-height: 40px;
    text-align: center;
}
.sale-name-ym {
    width: 150px;
    height: 40px;
    font-size: 24px;
    color: #a0acb5;
    line-height: 40px;
    text-align: left;
    margin-right: 20px;
}
.sale-name-ks {
    width: 150px;
    height: 40px;
    font-size: 24px;
    color: #a0acb5;
    line-height: 40px;
    text-align: center;
}
.sale-num {
    width: 100px;
    height: 40px;
    font-size: 28px;
    font-weight: 700;
    color: #35434c;
    line-height: 40px;
    text-align: center;
    margin-top: 10px;
}
.sale-num-ym {
    width: 150px;
    height: 40px;
    font-size: 28px;
    font-weight: 700;
    color: #35434c;
    line-height: 40px;
    text-align: left;
    margin-top: 10px;
    margin-right: 20px;
}
.sale-num-ks {
    width: 150px;
    height: 40px;
    font-size: 28px;
    font-weight: 700;
    color: #35434c;
    line-height: 40px;
    text-align: center;
    margin-top: 10px;
}
.txt-center {
    text-align: center;
}

.sale-number {
    height: 45px;
    font-size: 28px;
    color: #35434c;
    line-height: 45px;
    margin-top: 28px;
    min-width: 40px;
    font-weight: 700;
}
.select-box {
    margin-left: 30px;
    margin-right: 30px;
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}

.van-pull-refresh {
    min-height: 100%;
}

:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}
input {
    &::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #c8c9cc;
    }

    &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #c8c9cc;
    }

    &::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #c8c9cc;
    }
}
:deep(.search-button.van-search) {
    padding: 30px 30px 30px 30px;
}
:deep(.search-button .van-icon) {
    font-size: 28px;
}
:deep(.search-button .van-search__content) {
    padding-left: 20px !important;
}
:deep(.search-button .van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 0 !important;
    margin-right: 0 !important;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
</style>

